/**
 * Shared helpers for the email customer-override flow.
 *
 * Lives in a .ts sibling (not CustomerSearch.tsx) because the ESLint
 * react-refresh/only-export-components rule forbids exporting plain
 * functions from component modules.
 */
import type { LinkedOrderState } from '../../types/portal';

/** True when any linked order diverges and is actionable (editable) or notable
 *  (already in Sage) — i.e. the reassignment → order safety-valve should ask.
 *  Used by CustomerSearch and ProposalCard, which apply the same override path. */
export const needsOrderDecision = (linkedOrders: LinkedOrderState[]): boolean =>
  linkedOrders.some(
    (o) => o.customer_diverges && (o.editable || o.sage_locked),
  );
